import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { getGQLDeviceList, getGQLDeviceListForCareTeam } from "../../api/device";

export const getDeviceList = createAsyncThunk("device/getDeviceList", async (_, { rejectWithValue, getState }) => {
  try {
    const loggedInUser = getState().auth.user;
    const response = loggedInUser.userTypeId === 5 ? await getGQLDeviceList(loggedInUser.orgId) : await getGQLDeviceListForCareTeam(loggedInUser.userId);
    return response?.body;
  } catch (error) {
    return rejectWithValue(error);
  }
});

const deviceSlice = createSlice({
  name: "device",
  initialState: {
    deviceList: null,
    rowCount: null,
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getDeviceList.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getDeviceList.fulfilled, (state, action) => {
        state.loading = false;
        state.deviceList = action.payload?.data;
        state.rowCount = action.payload?.rowCount;
        state.error = null;
      })
      .addCase(getDeviceList.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
  },
});

export default deviceSlice.reducer;
